<template>
  <div class="list-panel">
    <template v-for="department in departmentData">
      <department-option
        :key="department.id"
        :department="department"
        :selectType="selectType"
        @click.native="handleClick(department)"
      ></department-option>
    </template>
    <template v-if="departmentData.length === 0">
      <x-empty></x-empty>
    </template>
  </div>
</template>

<script>
import DepartmentOption from '../department-option/department-option'
import apis from '@/api'
import { mapState } from 'vuex'

export default {
  components: {
    DepartmentOption
  },
  props: {
    selectType: {
      type: String,
      default: 'SINGLE'
    },
    keyWord: {
      type: String,
      default: ''
    },
    canSelectAll: {
      type: Boolean,
      default: true
    },
    // 用于判断是否使用过滤
    isTile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      departmentData: []
    }
  },
  computed: {
    ...mapState({
      selectedArray: state => state.departmentModule.selectedArray,
      compPayload: state => state.compRouterModule.compPayload
    }),
    isAllSelected() {
      return this.departmentData.some(item => this.selectedArray.findIndex(_item => _item.id === item.id) === -1)
    }
  },
  watch: {
    'selectedArray': {
      handler(newVal, oldVal) {
        this.updateDepartmentData(newVal)
      }
    },
    'keyWord': {
      handler(newVal, oldVal) {
        if (this.isTile) {
          this.queryAllDepartmentFilter(this.keyWord).then(data => {
            this.init(data)
          })
        } else {
          this.queryAllDepartment(this.keyWord).then(data => {
            this.init(data)
          })
        }
      }
    },
    'isAllSelected': {
      handler(newVal, oldVal) {
        this.$emit('update:canSelectAll', newVal)
      },
      immediate: true
    }
  },
  created() {
    if (this.isTile) {
      this.queryAllDepartmentFilter(this.keyWord).then(data => {
        this.init(data)
      })
    } else {
      this.queryAllDepartment(this.keyWord).then(data => {
        this.init(data)
      })
    }
  },
  methods: {
    init(data) {
      this.departmentData = data.map(item => {
        const index = this.selectedArray.findIndex(_item => _item.id === item.id)
        if (index !== -1) {
          item.checked = true
        } else {
          item.checked = false
        }
        return item
      })
    },
    handleClick(department) {
      department.checked = !department.checked
      this.$emit('select', department)
    },
    queryAllDepartment(keyWord) {
      this.$loading.show()
      return new Promise((resolve, reject) => {
        const request = {
          ...apis.COMPONENT.QUERY_ALL_DEPARTMENT,
          params: {
            keyword: keyWord
          }
        }
        this.$request(request).asyncThen((resp) => {
          this.$loading.hide()
          if (resp.code === 'ok') {
            resolve(resp.data)
          }
        }, (err) => {
          this.$loading.hide()
        }).asyncErrorCatch(err => {
          this.$loading.hide()
        })
      })
    },
    queryAllDepartmentFilter(keyWord) {
      this.$loading.show()
      return new Promise((resolve, reject) => {
        const request = {
          ...apis.COMPONENT.QUERY_DEPARTMENT_FILTER,
          params: {
            param: {
              keyWord: keyWord
            },
            formData: this.compPayload[this.$route.query.key].formData,
            formId: this.$route.query.formId,
            componentId: this.$route.query.key
          }
        }
        this.$request(request).asyncThen((resp) => {
          this.$loading.hide()
          if (resp.code === 'ok') {
            resolve(resp.data)
          }
        }, (err) => {
          this.$loading.hide()
        }).asyncErrorCatch(err => {
          this.$loading.hide()
        })
      })
    },
    updateDepartmentData(selectedArray) {
      this.departmentData.forEach(item => {
        const index = this.selectedArray.findIndex(_item => _item.id === item.id)
        item.checked = index !== -1
      })
    },
    handleSelectAll(checked) {
      this.departmentData.forEach(department => {
        department.checked = checked
        this.$emit('select', department)
      })
    }
  }
}
</script>

<style lang="scss">
.list-panel {
  .x-empty {
    margin: 40% auto;
  }
}
</style>
